export default "__VITE_ASSET__DcpXsbsG__"